<script>
import axios from 'axios';
import AS from '@/services/AuthenticationService';

export default {
  all({ page, limit, q }) {
    return axios.get(`tipos-requerimentos?page=${page}&limit=${limit}&q=${q}`, AS.getDefaultHeaders());
  },
  show(id) {
    return axios.get(`tipos-requerimentos/${id}`, AS.getDefaultHeaders());
  },
  createOrUpdate(payload) {
    if (payload.id === null) {
      return axios.post('tipos-requerimentos', payload, AS.getDefaultHeaders());
    }
    return axios.patch(`tipos-requerimentos/${payload.id}`, payload, AS.getDefaultHeaders());
  },
  destroy(id) {
    return axios.delete(`tipos-requerimentos/${id}`)
  },

  fetchApplicationTypes() {
    return axios.get('tipos-requerimentos?all=true', AS.getDefaultHeaders());
  },
  fetchApplicationTypesSelectable() {
    return axios.get('tipos-requerimentos/application-types-selectables', AS.getDefaultHeaders());
  },
};
</script>
